import { Box, Divider, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      fontWeight: 400,
      borderRadius: theme.spacing(2),
      background: theme.palette.background.contentCardGrey,
      padding: theme.spacing(2),
      width: "100%",

      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    stack: {
      flex: "0 0 auto" 
    },
    table: {
      width: "100%",
      marginTop: theme.spacing(1),
      "& td": {
        border: "none",
        padding: theme.spacing(1),
        paddingLeft: 0,
        paddingBottom: theme.spacing(0.5),
        paddingTop: theme.spacing(0.5),
        verticalAlign: "top"
      },
      "& td:first-of-type": {
        width: "140px"
      }
    }
  })
);

export default function SectionCard(props) {
  const { title, icon, className, footer } = props;
  const { classes } = useStyles();

  return (
    <Box className={`${classes.root} ${className || ""}`}>
      <Stack className={classes.stack}>

        <Stack direction="row" spacing={1} alignItems="center">
          {icon}
          <Typography variant="subtitle1">
            {title}
          </Typography>
        </Stack>

        <Table className={classes.table}>
          <TableBody>
            {props.children}
          </TableBody>
        </Table>

      </Stack>

      {footer}

    </Box>
  );
}



export function SectionRow(props) {
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2" color="textSecondary">{props.title}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{props.children}</Typography>
      </TableCell>
    </TableRow>
  );
}

export function SectionSubHeader(props) {
  return (
    <TableRow>
      <TableCell colSpan={2}>
        <Typography variant="subtitle2">{props.title}</Typography>
      </TableCell>
    </TableRow>
  );
}


export function SectionDivider() {
  return (
    <TableRow>
      <TableCell colSpan={2}>
        <Divider />
      </TableCell>
    </TableRow>
  );
}

